import { Component } from '@angular/core';

@Component({
    selector: 'app-prd-sup',
    templateUrl: './prd-sup.component.html',
    styleUrls: ['./prd-sup.component.css']
})
/** prd-sup component*/
export class PrdSupComponent {
    /** prd-sup ctor */
    constructor() {
      console.log('PrdSupComponent start');
    }
}
